app.controller('itemViewCtrl', ["$rootScope", "$scope", "_API_URL", "$state", "$window", "shareData", "modalFactory", "modalService", "$filter", "urlServices", "_VAR_GLOBAL", "toaster", "$location", function ($rootScope, $scope, _API_URL, $state, $window, shareData, modalFactory, modalService, $filter, urlServices, _VAR_GLOBAL, toaster, $location) {
    
    // 1. Inisialisasi awal
    $scope.filter = '';
    $scope.dataList = {
        totalItems: 0,
        summary: {},
        data: []
    };

    $scope.paginationOptions = {
        pageNumber: 1,
        pageSize: _VAR_GLOBAL.limit,
        sort: null
    };

    // 2. Fungsi Refresh
    $scope.refreshData = function () {
        return $scope.viewData(1);
    };

    // 3. Fungsi Navigasi Halaman
    $scope.viewData = function (pg, qry) {
        $scope.paginationOptions.pageNumber = pg;
        // Kita panggil getData dengan parameter yang sesuai
        $scope.getData($scope.paginationOptions.pageSize, $scope.paginationOptions.pageNumber, $scope.filter, qry);
    };

    // 4. Core Function: Ambil Data dari Node.js (itemController)
    $scope.getData = function (pageSize, page, searchText, qry) {
        setTimeout(function () {
            var dataParams = '';
            
            // Menyesuaikan parameter dengan item_controller.js (limit, pg, term)
            if (searchText) {
                var ft = searchText.toLowerCase();
                dataParams = 'term=' + ft + '&limit=' + pageSize + '&pg=' + page;
            } else {
                dataParams = 'limit=' + pageSize + '&pg=' + page;
            }

            console.log('----> Requesting Item Data:', dataParams);
            
            // Memanggil endpoint 'item' sesuai dengan router.route('/item') di Node.js
            urlServices.ambilData('api/purchase-item?' + dataParams, {}, function (err, sukses) {
                if (err) {
                    console.error("Error API:", err);
                    toaster.pop('error', 'Error', 'Gagal mengambil data item');
                    $scope.dataList.totalItems = 0;
                    $scope.dataList.data = [];
                } else {
                    /* * Mapping Data: 
                     * Node.js Anda mengirim: { total: X, dt: [...] }
                     * Karena Node.js menggunakan func.result(result), data biasanya ada di sukses.data
                     */
                    var responseData = sukses.data ? sukses.data : sukses;
                    
                    // Kita hubungkan hasil.total ke totalItems dan hasil.dt ke data
                    $scope.dataList.totalItems = responseData.total || 0;
                    $scope.dataList.data = responseData.dt || [];
                    
                    console.log("Data Berhasil Dimuat:", $scope.dataList.data.length, "item ditemukan");
                }
            });
        }, 100);
    };

        // 1. Fungsi Edit (Bisa edit data)
    $scope.edit = function(n) {
        var kode = n.KodeBarang || n.kodebarang;
        window.location = _API_URL + 'purchase-item-entry?screen=item&isedit=true&kodebarang=' + kode;
    };

    // 2. Fungsi Detail (Hanya lihat, input terkunci)
    $scope.detail = function(n) {
        var kode = n.KodeBarang || n.kodebarang;
        window.location = _API_URL + 'purchase-item-entry?screen=item&isedit=true&isview=true&kodebarang=' + kode;
    };

    // 3. Fungsi Hapus (Dengan Konfirmasi)
    $scope.hapus = function(n) {
        var kode = n.KodeBarang || n.kodebarang;
        modalService.showModal({}, {
            headerText: 'Hapus Barang',
            bodyText: 'Apakah Anda yakin ingin menghapus [' + kode + '] ?'
        }).then(function (result) {
            if (result) {
                urlServices.simpanData('api/purchase-item-delete', { KodeBarang: kode }, function (err, sukses) {
                    if (err) {
                        toaster.pop('error', 'Perhatian', err);
                    } else {
                        toaster.pop('success', 'Berhasil', 'Data berhasil dihapus');
                        $scope.viewData(1); // Refresh tabel
                    }
                });
            }
        });
    };

    // 6. Jalankan pertama kali saat halaman dibuka
    $scope.viewData(1);

}]);

app.controller('itemTrxCtrl', ["$rootScope", "$scope", "$state", "$location", "$filter", "urlServices", "modalService", "modalFactory", "toaster", "_VAR_GLOBAL", "_API_URL", function ($rootScope, $scope, $state, $location, $filter, urlServices, modalService, modalFactory, toaster, _VAR_GLOBAL, _API_URL) {
    
    // --- 1. INISIALISASI DATA ---
    $scope.data = {}; 
    $scope.listKategori = [];
    $scope.listSatuan = [];
    $scope.detailJournal = [];
    $scope.isEdit = false;

    // Default object untuk baris baru di tabel (jika ada)
    var defaultJournal = {
        Satuan: "PCS",
        HargaSatuan: 0,
        Qty: 1,
        SubTotal: 0.00
    };

    function normalizeSubKategori(value) {
        var normalized = (value || "").toString().trim().toUpperCase();
        return normalized === "BARANG" || normalized === "JASA" ? normalized : "";
    }

    // --- 2. LOGIKA DROPDOWN (Penerapan Baru) ---
    $scope.getKategori = function() {
        urlServices.ambilData('api/get-kategori', {}, function (err, sukses) {
            if (!err) {
                // Menangani wrapper sukses.data dari func.result backend
                var res = sukses.data ? sukses.data : sukses;
                $scope.listKategori = res.dt || []; 
            }
        });
    };

    $scope.getSatuan = function() {
        urlServices.ambilData('api/get-satuan', {}, function (err, sukses) {
            if (!err) {
                var res = sukses.data ? sukses.data : sukses;
                $scope.listSatuan = res.dt || [];
            }
        });
    };

    // Jalankan pengisian dropdown saat controller dimuat
    $scope.getKategori();
    $scope.getSatuan();


    $scope.isEdit = urlServices.getUrlParameter('isedit') == 'true';
    $scope.isView = urlServices.getUrlParameter('isview') == 'true';

    // FUNGSI UNTUK SET DEFAULT / RESET
        $scope.resetForm = function() {
            $scope.data = {
                Aset: 1,      // Default Tercentang
                Aktif: 1,     // Default Tercentang
                SubKategori: "",
                Stok: 0,      // Opsional: inisialisasi angka agar tidak null
                HargaBeli: 0,
                HargaJual: 0,
                Margin: 0
            };
            // Jika ada form validation, bisa direset di sini:
            // if($scope.frmExpenseTrx) $scope.frmExpenseTrx.$setPristine();
        };

        // JALANKAN DEFAULT HANYA JIKA TAMBAH BARU
        if (!$scope.isEdit) {
            $scope.resetForm();
        }

    if ($scope.isEdit) {
            // Ambil parameter dari URL
            var kode = urlServices.getUrlParameter('kodebarang'); 
            
            // Debugging: Munculkan di console browser untuk memastikan kodenya tertangkap
            console.log("Mengambil data untuk kode:", kode); 

            if (kode) {
                urlServices.ambilData('api/purchase-item/' + kode, {}, function (err, res) {
                    if (err) {
                        console.error("Error API:", err);
                        toaster.pop('error', 'Server Error', 'Gagal mengambil data dari database');
                    } else {
                        // Pastikan struktur response sesuai
                        $scope.data = res.data ? res.data : res;
                        $scope.data.SubKategori = normalizeSubKategori($scope.data.SubKategori || $scope.data.SubKategoriBarang);
                       // --- UPDATE BAGIAN INI ---

                       // --- SOLUSI CHECKBOX ---
                        // Paksa konversi ke String "1" agar terbaca oleh ng-true-value="1"
                        // Ini berlaku untuk View dan Edit
                        $scope.data.Aset = ($scope.data.Aset == 1 || $scope.data.Aset == "1" || $scope.data.Aset == true) ? "1" : "0";
                        $scope.data.Aktif = ($scope.data.Aktif == 1 || $scope.data.Aktif == "1" || $scope.data.Aktif == true) ? "1" : "0";
                        
                        $scope.kodeLama = $scope.data.KodeBarang; // Kode asli untuk query UPDATE
                        
                        // Simpan kategori asli
                        $scope.kategoriAsli = $scope.data.KodeItem; 
                        
                        // Simpan inisial nama asli (pakai fungsi ambilInisial)
                        $scope.inisialAsli = ambilInisial($scope.data.NamaBarang); 
                        
                        console.log("Data berhasil dimuat. Kunci Asli:", $scope.kategoriAsli + "-" + $scope.inisialAsli);
                        console.log("Data berhasil dimuat:", $scope.data);
                       
                }
                
            });
        }
    }   
    
    function ambilInisial(nama) {
            if (!nama) return "";
            
            // Pecah berdasarkan spasi untuk mendapatkan kata-kata
            var words = nama.trim().split(/\s+/);
            var initial = "";

            if (words.length >= 2) {
                // Ambil huruf alfabet saja dari Kata 1 dan Kata 2
                var word1Alpha = words[0].replace(/[^a-zA-Z]/g, '');
                var word2Alpha = words[1].replace(/[^a-zA-Z]/g, '');
                
                // Cek apakah kedua kata tersebut memiliki setidaknya 1 huruf alfabet
                if (word1Alpha.length >= 1 && word2Alpha.length >= 1) {
                    initial = word1Alpha.charAt(0) + word2Alpha.charAt(0);
                } else {
                    // Jika salah satu kata murni angka/simbol (misal: "Besi 10mm"), 
                    // kita ambil 2 huruf alfabet pertama dari keseluruhan nama barang
                    var allAlpha = nama.replace(/[^a-zA-Z]/g, '');
                    initial = allAlpha.substring(0, 2);
                }
            } else {
                // Jika hanya 1 kata
                // Buang semua selain huruf, lalu ambil 2 huruf pertama
                var allAlpha = nama.replace(/[^a-zA-Z]/g, '');
                initial = allAlpha.substring(0, 2);
            }
            
            return initial.toUpperCase();
        }
                

    $scope.saveItem = function() {
            $scope.data.SubKategori = normalizeSubKategori($scope.data.SubKategori || $scope.data.SubKategoriBarang);

            // 1. Validasi Input Mandatori
            if (!$scope.data.KodeItem || !$scope.data.Satuan || !$scope.data.NamaBarang || !$scope.data.SubKategori) {
                return toaster.pop('warning', 'Validasi', 'Kategori, Sub-Kategori, Satuan, dan Nama Barang wajib diisi!');
            }

            var urlSave = 'api/purchase-item-save?isedit=' + $scope.isEdit;
                
            if($scope.isEdit) {
                    urlSave += '&kodeLama=' + $scope.kodeLama;
                }

            // Tampilkan loading (opsional)
            toaster.pop('wait', 'Proses', 'Sedang menyimpan data...');

            // 2. Kirim Data ke API
            urlServices.simpanData( urlSave , $scope.data, function (err, res) {
                if (err) {
                    // JIKA GAGAL: Tampilkan pesan error dari backend
                    toaster.pop('error', 'Gagal Simpan', err);
                } else {
                    // JIKA BERHASIL: Tampilkan pesan sukses
                    toaster.pop('success', 'Berhasil', 'Data barang berhasil ' + ($scope.isEdit ? 'diperbarui' : 'disimpan'));

                    // Kasih jeda 1.5 detik supaya user bisa baca pop-up sukses baru pindah halaman
                    setTimeout(function() {
                        window.location = _API_URL + 'purchase-item';
                    }, 1500); 
                }
            });
        };

    $scope.generateAutomaticCode = function() {
                // 0. Cek apakah field utama sudah terisi
                if ($scope.data.KodeItem && $scope.data.NamaBarang && $scope.data.NamaBarang.length >= 1) {
                    
                    // 1. Olah Inisial Nama (Logika: 2 kata = ambil depan-depan, 1 kata = ambil 2 huruf)
                   var initial = ambilInisial($scope.data.NamaBarang);
        
                    // Jika ternyata setelah di-filter tidak ada huruf sama sekali (misal isinya "12345" saja)
                    // Kita bisa set default fallback, misal "XX", atau biarkan kosong.
                     if (!initial) {
                            // Fallback 1: Jika tidak ada huruf sama sekali (misal isinya "12345" saja)
                            initial = "XX"; 
                        } else if (initial.length === 1) {
                            // Fallback 2: Jika setelah difilter ternyata hanya tersisa 1 huruf (misal isinya "A 123")
                            initial = initial + "X"; 
                        }
                    
                    // 2. Olah Prefix Kategori
                    var cleanKategori = $scope.data.KodeItem.split(' ')[0].trim();
                    var prefix = (cleanKategori + "-" + initial).replace(/\s+/g, ''); 

                    // --- LOGIKA KUNCI ASLI (START) ---
                    if ($scope.isEdit) {
                        // Kita bandingkan kategori dan inisial yang sedang diketik dengan yang asli dari DB
                        var kategoriMasihSama = ($scope.data.KodeItem === $scope.kategoriAsli);
                        var inisialMasihSama = (initial === $scope.inisialAsli);

                        if (kategoriMasihSama && inisialMasihSama) {
                            console.log("Tidak ada perubahan fundamental (Kategori & Inisial sama). Mengunci kode lama.");
                            $scope.data.KodeBarang = $scope.kodeLama; // Kembalikan ke kode awal
                            return; // STOP di sini, jangan panggil API get-last-code
                        }
                    }
                    // --- LOGIKA KUNCI ASLI (END) ---

                    console.log("Ada perubahan atau data baru. Generate kode untuk prefix:", prefix);

                    // 3. Panggil API untuk ambil nomor urut terakhir jika ada perubahan/data baru
                    var urlDenganParam = 'api/get-last-code?prefix=' + prefix;
                    urlServices.ambilData(urlDenganParam, {}, function (err, response) {
                        if (!err && response) {
                            var resData = response.dt ? response.dt : (response.data ? response.data : response);
                            var counter = resData.newCounter || "001";

                            $scope.data.KodeBarang = prefix + counter;
                            
                            if (!$scope.$$phase) $scope.$apply();
                        }
                    });

                } else {
                    // Kosongkan kode jika Nama atau Kategori dihapus
                    $scope.data.KodeBarang = "";
                }
            };
    
    $scope.generateAutomaticNamaBarang = function() {
                // Ambil semua komponen, gunakan string kosong jika undefined
                var jenis = $scope.data.JenisBarang || "";
                var tipe = $scope.data.TipeBarang || "";
                var spesifikasi = $scope.data.Spesifikasi || "";
                var aplikasi = $scope.data.Aplikasi || "";
                var brand = $scope.data.Brand || "";

                // Masukkan ke dalam array, filter yang isinya kosong, lalu gabungkan dengan spasi
                var gabung = [jenis, tipe, spesifikasi, aplikasi, brand]
                    .filter(function(val) {
                        return val.trim() !== ""; // Hanya ambil yang ada isinya
                    })
                    .join(" "); // Gabungkan dengan spasi

                // Update NamaBarang
                $scope.data.NamaBarang = gabung.toUpperCase();

                // SANGAT PENTING: Panggil generateAutomaticCode agar KODE otomatis terupdate 
                // setiap kali NAMA BARANG berubah dari input-input ini
                $scope.generateAutomaticCode();
            };

            $scope.generateAutomaticMargin = function() {
                    // Pastikan harga adalah angka, jika tidak ada isinya anggap 0
                    var beli = parseFloat($scope.data.HargaBeli) || 0;
                    var jual = parseFloat($scope.data.HargaJual) || 0;

                    // Hitung selisihnya
                    var margin = jual - beli;

                    // Masukkan ke model data.Margin
                    $scope.data.Margin = margin;

                    // Jika Anda ingin menghitung Harga Pokok secara otomatis (opsional)
                    // $scope.data.HargaPokok = beli;
                };

}]);